/**
 * Tooltip implementation of the Popper component
 */
import React from 'react';

import { Direction, Popper } from '~shared/components/Popper/Popper';

type MaxWidth = number | string;

const PopoverContent = ({ content, maxWidth = 370 }: { content: React.ReactNode; maxWidth?: MaxWidth }) => {
  const maxWidthStyle = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth;
  return (
    <div
      style={{
        maxWidth: maxWidthStyle,
        boxShadow: '0px 16px 72px 0px #00000029',
      }}
      className={'rounded-2 bg-white p-8'}
    >
      {content}
    </div>
  );
};
interface PopoverProps {
  content: React.ReactNode;
  delay?: number;
  enablePersistence?: boolean;
  children: React.ReactNode;
  disableArrow?: boolean;
  direction?: Direction;
  isDisabled?: boolean;
  mode?: 'click' | 'hover' | 'context';
  maxWidth?: MaxWidth;
}

export const Popover = ({
  content,
  delay,
  enablePersistence,
  children,
  disableArrow,
  direction,
  isDisabled,
  mode = 'hover',
  maxWidth,
}: PopoverProps) => {
  return (
    <Popper
      theme={'light'}
      mode={mode}
      isDisabled={isDisabled}
      direction={direction || 'top'}
      content={<PopoverContent content={content} maxWidth={maxWidth} />}
      enableArrow={disableArrow ? undefined : true}
      delay={delay || 200}
      enablePersistence={enablePersistence ? true : undefined}
    >
      {children}
    </Popper>
  );
};
